import { gql, useMutation } from '@apollo/client';

export const EDIT_INTERVENTION_MUTATION = gql`
  mutation EditIntervention($input: InterventionEdit!) {
    editIntervention(input: $input) {
      _id
      obs
      photosTaken
      technicianId
      createdAt
      type
    }
  }
`;
